import React from 'react';
import DiagramQ3Workflow from '../diagrams/DiagramQ3Workflow';

export default function SectionQ3Internal() {
  return (
    <div className="space-y-4" data-testid="section-q3-internal">
      <div>
        <h3 className="text-base font-bold text-slate-800 mb-1">Q3 — Werk-zu-Werk-Reklamation (intern)</h3>
        <p className="text-xs text-slate-500">Interner Prozess für Qualitätsabweichungen zwischen internen Produktionsstandorten.</p>
      </div>

      <div className="p-3 rounded-lg bg-blue-50 border border-blue-200 text-xs text-blue-900">
        <strong className="block mb-1">Wann Q3 statt Q1?</strong>
        Wenn ein internes Werk Halb- oder Fertigfabrikate von einem anderen internen Werk
        erhält und dabei Qualitätsabweichungen feststellt, wird Q3 angelegt.
        Es handelt sich nicht um eine Kundenreklamation — die Kosten werden intern verrechnet.
      </div>

      <DiagramQ3Workflow />

      <div>
        <h4 className="text-sm font-bold text-slate-800 mb-2">Regeln</h4>
        <ul className="text-xs space-y-1.5 ml-4 list-disc text-slate-700">
          <li><strong>Verantwortung:</strong> Das <em>abgebende Werk</em> (Produktion) ist immer für die Ursachenanalyse und Korrekturmaßnahmen verantwortlich.</li>
          <li><strong>Meldefrist:</strong> 30 Arbeitstage ab Wareneingang des empfangenden Werks.</li>
          <li><strong>Verdeckte Fehler:</strong> Bei später entdeckten Fehlern beginnt die Frist ab Entdeckung.</li>
          <li><strong>Kostenstelle:</strong> Kosten werden auf die KST des abgebenden Werks umgebucht.</li>
          <li><strong>8D-Workflow:</strong> Identisch zu Q1 (D0-D8), aber Kostenstellen und Eskalation werk-spezifisch.</li>
        </ul>
      </div>

      <div>
        <h4 className="text-sm font-bold text-slate-800 mb-2">Typische Beispiele</h4>
        <div className="grid sm:grid-cols-3 gap-2 text-xs">
          <div className="p-2 rounded border border-slate-200 bg-white">
            <div className="font-semibold text-slate-800 mb-0.5">Halbfabrikat-Defekt</div>
            <div className="text-slate-600">Werk A liefert Rohling mit Gefügefehler an Werk B.</div>
          </div>
          <div className="p-2 rounded border border-slate-200 bg-white">
            <div className="font-semibold text-slate-800 mb-0.5">Rost/Korrosion</div>
            <div className="text-slate-600">Transportbedingte Oxidation bei verlängerter Lagerung.</div>
          </div>
          <div className="p-2 rounded border border-slate-200 bg-white">
            <div className="font-semibold text-slate-800 mb-0.5">Oberflächen-Kratzer</div>
            <div className="text-slate-600">Mechanische Beschädigung durch unzureichende Verpackung.</div>
          </div>
        </div>
      </div>
    </div>
  );
}
